module.exports = __webpack_public_path__ + "img/wd_logo.91562385.png";